import { render } from "./MyKatudo.vue?vue&type=template&id=0160f8e8&scoped=true"
import script from "./MyKatudo.vue?vue&type=script&lang=js"
export * from "./MyKatudo.vue?vue&type=script&lang=js"

import "./MyKatudo.vue?vue&type=style&index=0&id=0160f8e8&scoped=true&lang=css"

import exportComponent from "D:\\作業\\GitlabWebシステム\\ｱ_青森市社会福祉協議会_Webボランティアシステム\\Web-Volunteer-Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0160f8e8"]])

export default __exports__